import React from 'react';
import { reportError } from 'api/api-errors';

import config from '../../../config';

export function gotoLastPost(postId, newWindow = false) {
  this.api.get(`action/forum/actions-find-page/get-last-post?type=posts&id=${postId}`)
    .then((payload) => {
      let href = `${payload.lastPageUrl}#post-${postId}`;
      if (newWindow && href) {
        href = `//${config.domains['forum']}${href}`;
        return window.open(href, '_blank');
      };
      if (href) this.props.router.push(href);
    })
    .catch(error => reportError(error));
}

export function gotoPostById(postId, newWindow = false) {
  this.api.get(`action/forum/actions-find-page/get-page-by-post?&post_id=${postId}`)
    .then((payload) => {
      let href = `/${payload.url}#post-${postId}`;
      if (newWindow && href) {
        href = `//${config.domains['forum']}${href}`;
        return window.open(href, '_blank');
      }
      if (href) this.props.router.push(href);
    })
    .catch(error => reportError(error));
}
